import React from 'react'

/* eslint-disable import/prefer-default-export */
export function ShareIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
      <g clipPath="url(#clip0_5003_135)">
        <path
          d="M2.91632 15.525C4.20225 14.1555 7.57803 11.25 12.3749 11.25V15L18.6249 8.75L12.3749 2.5V6.25C8.24991 6.25 2.96163 10.1914 2.37491 15.2766C2.36679 15.3424 2.37983 15.4091 2.41216 15.4671C2.44449 15.525 2.49442 15.5712 2.55473 15.5988C2.61503 15.6265 2.68258 15.6343 2.74759 15.621C2.81259 15.6077 2.87169 15.5741 2.91632 15.525Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5003_135">
          <rect width="20" height="20" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}
